import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import AsyncComponentContext from 'page-editor-ui/context/AsyncComponentContext';
import ThemeMofoFields from 'theme-previewer-lib/components/ThemeMofoFields';
import AsyncComponentsContext from 'page-editor-ui/context/AsyncComponentContext';
import { makeAsyncComponent } from 'theme-previewer-lib/utils/makeAsyncUtils';
import UniversalEditorAppContainer from 'theme-previewer-lib/containers/UniversalEditorAppContainer';
import { UNIVERSAL_THEME_EDITING_APPS } from 'theme-previewer-lib/constants';
import { getTemplatePath } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { fetchPageCssAssets } from 'ContentEditorUI/redux/actions/contentAssetsActions';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
// @ts-ignore not typed yet
import { routeToPage } from 'ContentEditorUI/redux/actions/routingActions';
// @ts-ignore not typed yet
import { closePatagoniaSidebar } from 'ContentEditorUI/redux/actions/panelActions';

// @ts-ignore non-ts module import
import { setSuperstoreUserSetting } from 'ContentEditorUI/redux/actions/settingsActions';
// @ts-ignore non-ts module import
import { HAS_OPENED_UNIVERSAL_THEME_EDITOR_PANEL } from 'ContentEditorUI/lib/userAndLocalCacheSettings/constants';
import { getHasOpenedUniversalThemeEditorPanel } from 'ContentEditorUI/redux/selectors/localCachedSettingsSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncEPDependentsPanel = makeAsyncComponent(() => import( /* webpackChunkName: 'EPDependentsPanel' */'theme-previewer-lib/components/EPDependentsPanel'));
const ThemeEditorContainer = () => {
  const dispatch = useDispatch();
  const hasOpenedUniversalThemeEditorPanel = useSelector(getHasOpenedUniversalThemeEditorPanel);
  useEffect(() => {
    if (!hasOpenedUniversalThemeEditorPanel) {
      dispatch(setSuperstoreUserSetting(HAS_OPENED_UNIVERSAL_THEME_EDITOR_PANEL, true));
    }
  }, [dispatch, hasOpenedUniversalThemeEditorPanel]);
  const AsyncComponents = {
    ThemeMofoFields,
    EPDependentsPanel: AsyncEPDependentsPanel
  };
  const trackUpdateThemeSettings = (properties = {}) => {
    UsageTracker.trackEditorInteraction(Object.assign({}, properties, {
      event: 'update-global-theme-settings'
    }));
  };
  const templatePath = useSelector(getTemplatePath);
  const reloadIframePreview = () => {
    dispatch(fetchPageCssAssets());
    const bus = window.hubspot.ContentEditorUI.eventBus;
    bus.trigger('preview:refresh');
  };
  const handleOpenRevisionsModal = () => {
    dispatch(routeToPage('revisions'));
  };
  const handleClosePatagoniaSidebar = () => {
    dispatch(closePatagoniaSidebar());
  };
  return /*#__PURE__*/_jsx(AsyncComponentContext.Provider, {
    value: AsyncComponents,
    children: /*#__PURE__*/_jsx(UniversalEditorAppContainer, {
      AsyncComponentContext: AsyncComponentsContext,
      fromAppName: UNIVERSAL_THEME_EDITING_APPS.PAGE_EDITOR,
      templatePath: templatePath,
      reloadIframePreview: reloadIframePreview,
      trackUpdateThemeSettings: trackUpdateThemeSettings,
      handleOpenRevisionsModal: handleOpenRevisionsModal,
      handleClosePatagoniaSidebar: handleClosePatagoniaSidebar
    })
  });
};
export default ThemeEditorContainer;